import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import LastActivity from '@/components/common/LastActivity.vue'
  import eventBus from '@/main'
  import type { PropType } from 'vue'
  import type { CourseItem, CoursePackage } from '@/services/interfaces/Course'
  import type { UserCourseActivity } from '@/services/interfaces/Auth0'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalCourses',
  props: {
    user: {
      type: Object as PropType<{ id: string; name: string; email: string }>,
      required: true,
    },
    groupedCourses: {
      type: Object as PropType<{ [key: string]: (CourseItem | CoursePackage)[] }>,
      required: true,
    },
    headerTitle: {
      type: Function as PropType<(key: string) => string>,
      required: true,
    },
    isPurchasedItem: {
      type: Function as PropType<(item: CourseItem | CoursePackage) => boolean>,
      required: true,
    },
    isPurchasedCourse: {
      type: Function as PropType<(courseId: string) => boolean>,
      required: true,
    },
    getUserActivity: {
      type: Function as PropType<(courseId?: string) => UserCourseActivity | undefined>,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { thickCheckmark, arrowDown } = useIcons()
  const { currencyFormatDE } = useCommonMixin()
  const { createShopifyCheckout } = useShopifyClient()
  const { productPrice } = useCourse()

  const collapsedStates = ref({} as { [key: string]: boolean })

  const getItemKey = computed(() => (item: CourseItem | CoursePackage) => {
    return (item as CourseItem).id || (item as CoursePackage).courseBundleId
  })

  const buyCourse = (item: CourseItem | CoursePackage) => {
    if (props.isPurchasedItem(item)) return
    createShopifyCheckout(props.user?.email, item.shopifyProductVariantId)
  }

  const setCollapsedState = (key: string) => {
    if (key in collapsedStates.value) {
      collapsedStates.value[key] = !collapsedStates.value[key]
    } else {
      eventBus.$set(collapsedStates.value, key, true)
    }
  }

  const getCourseActivity = (item: CourseItem | CoursePackage) => {
    const courseId = (item as CourseItem).id
    return courseId ? props.getUserActivity(courseId) : undefined
  }

return { __sfc: true,props, thickCheckmark, arrowDown, currencyFormatDE, createShopifyCheckout, productPrice, collapsedStates, getItemKey, buyCourse, setCollapsedState, getCourseActivity, computed, ref, useIcons, useCommonMixin, SVGRenderer, LoadingSpinner, LastActivity, eventBus, useShopifyClient, useCourse }
}

})